export * from './ng4-files-drop.component';



// WEBPACK FOOTER //
// ./src/app/shelf/Clouddata/ng4-files/components/ng4-files-drop/index.ts